export default __webpack_public_path__ + "static/media/cert1.ee23a369.jpg";